import * as React from "react";
import classnames from "classnames";
import { Modal } from "@grandvisionhq/common";
import { appendQueryParamToUrl } from "@grandvisionhq/utils";
import { MiniCart } from "../../../../layouts/modules/MiniCart/layouts/MiniCart.js";
import { useMiniCartListener } from "../../../../utils/modules/MiniCart/utils/event.js";
const ModalContainer = ({ modal, ...rest }) => {
  const [lineItems, setLineItems] = React.useState(
    void 0
  );
  const [linksWithCardId, setLinksWithCardId] = React.useState({
    cart: void 0,
    checkout: void 0
  });
  const { links, ...restWithoutLinks } = rest;
  useMiniCartListener((event) => {
    const { cartId, cartHash, type } = event.detail;
    if (!lineItems || type === "updated") {
      setLinksWithCardId({
        cart: links?.cart ? appendQueryParamToUrl(links.cart, {
          ...cartId ? { cartId } : null,
          ...cartHash ? { cartHash } : null
        }) : void 0,
        checkout: links?.checkout ? appendQueryParamToUrl(links.checkout, {
          ...cartId ? { cartId } : null,
          ...cartHash ? { cartHash } : null
        }) : void 0
      });
      setLineItems(event.detail.lineItems);
    }
  });
  const handleClose = () => {
    setLineItems(void 0);
    modal?.onModalClose && modal.onModalClose();
  };
  return /* @__PURE__ */ React.createElement(
    Modal,
    {
      ...modal,
      className: classnames("mini-cart-v2", modal?.className),
      "data-t": "mini-cart-v2",
      isOpen: (!!lineItems || modal?.isOpen) ?? false,
      onModalClose: handleClose,
      showIcon: modal?.showIcon ?? true
    },
    lineItems ? /* @__PURE__ */ React.createElement(MiniCart, { lineItems, links: linksWithCardId, ...restWithoutLinks }) : null
  );
};
export {
  ModalContainer
};
//# sourceMappingURL=ModalContainer.js.map
